import React from "react";
import Subscription from "views/admin/subscription";
import Appointment from "views/admin/appointment";
import UserData from "views/admin/userData";
import SignIn from "views/auth/SignIn";
import { MdBarChart, MdLock, MdEvent, MdQuestionAnswer } from "react-icons/md";
import { BiData } from "react-icons/bi";
import { BsCashCoin } from "react-icons/bs";
import { FaHospitalUser } from "react-icons/fa";
import { FaUserDoctor } from "react-icons/fa6";
import SignOut from "views/auth/SignOut";
import PaymentLink from "views/admin/paymentLink";
import BookConsultation from "views/admin/bookConsultation";
import DoctorsAppointments from "components/DoctorsAppointments/DoctorsAppointments";
import SupportTasks from "components/SupportTasks/SupportTasks";
import { BiSupport } from "react-icons/bi";
import NightDoctorDuty from "components/nightDoctorDuty/nightDoctorDuty";
import { MdNightlight } from "react-icons/md";
import QNAs from "components/QNAs/QNAs";
import WorklistView from "views/admin/worklist";
import RetentionView from "views/admin/retention";
import { MdChecklist } from "react-icons/md";
import { MdOutlineLoyalty } from "react-icons/md";

// The Worklist is the landing screen and stays first: it is the single pane the whole
// shift runs from. The old Home dashboard (a wall of count tiles + an embedded WhatsApp
// chat console) is retired — every actionable thing it surfaced is a lane here now.
const routes = [
  {
    name: "Worklist",
    layout: "",
    icon: <MdChecklist className="text-xl" />,
    path: "worklist",
    component: <WorklistView />,
  },
  {
    name: "Retention",
    layout: "",
    icon: <MdOutlineLoyalty className="text-xl" />,
    path: "retention",
    component: <RetentionView />,
  },
  {
    name: "User Data",
    layout: "",
    path: "userdata",
    icon: <BiData className="text-xl" />,
    component: <UserData />,
  },
  {
    name: "Payment Link",
    layout: "",
    path: "payment",
    icon: <BsCashCoin className="text-lg" />,
    component: <PaymentLink />,
  },
  {
    name: "Subscription",
    layout: "",
    icon: <MdBarChart className="text-xl" />,
    path: "plan",
    component: <Subscription />,
  },
  {
    name: "Appointment",
    layout: "",
    icon: <MdEvent className="text-xl" />,
    path: "appointment",
    component: <Appointment />,
  },

  {
    name: "Book consultation",
    layout: "",
    path: "consultation",
    icon: <FaHospitalUser className="text-lg" />,
    component: <BookConsultation />,
  },
  {
    name: "QnAs",
    layout: "",
    path: "qnas",
    icon: <MdQuestionAnswer className="text-xl" />,
    component: <QNAs />,
  },
  {
    name: "Night Doctor DUty",
    layout: "",
    path: "night-duty",
    icon: <MdNightlight className="text-xl" />,
    component: <NightDoctorDuty />,
  },
  {
    name: "Support Tasks",
    layout: "",
    path: "support-tasks",
    icon: <BiSupport className="text-xl" />,
    component: <SupportTasks />,
  },
  {
    name: "Doctors Appointments",
    layout: "",
    path: "manage-doctors-appointments",
    icon: <FaUserDoctor className="text-xl" />,
    component: <DoctorsAppointments />,
  },
  {
    name: "Sign Out",
    layout: "/auth",
    path: "sign-out",
    icon: <MdLock className="text-xl" />,
    component: <SignOut />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: null,
    component: <SignIn />,
  },
];

export default routes;
